import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-trinka',
  templateUrl: './about-trinka.component.html',
  styleUrls: ['./about-trinka.component.scss']
})
export class AboutTrinkaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
